import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import styles from './ShowMore.module.scss';

type ShowMoreProps = {
  isLoading: boolean;
  onLoadMore: () => void;
  fullWidth?: boolean;
  text?: ReactNode;
  variant?: ComponentProps<typeof Button>['variant'];
};

const ShowMore = ({ isLoading, onLoadMore, fullWidth, text, variant = 'default' }: ShowMoreProps) => {
  return (
    <Button
      className={classNames(styles.showMore, { [styles.fullWidth]: fullWidth })}
      loading={isLoading}
      onClick={onLoadMore}
      testId="trail-reviews-show-more"
      text={text ?? <FormattedMessage defaultMessage="Show more" />}
      variant={variant}
      width={fullWidth ? 'full' : 'fullOnMobile'}
    />
  );
};

export default ShowMore;
